import React, { ChangeEvent, FunctionComponent, useCallback, useMemo, useState } from 'react';
import sortBy from 'lodash/sortBy';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { IUserListParams, IReducedUsers } from './types';
import { UserWidget } from './UserWidget';
import searchIcon from '../../../resources/images/search-icon.svg';

export const UserList: FunctionComponent<IUserListParams> = ({ onUserSelect, userIds }) => {
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds ?? []);
  const sortedUsers = sortBy(users.filter(Boolean), ['lastName', 'firstName']);

  const [searchParam, setSearchParam] = useState<string>('');

  const reduceByFullName = useMemo(
    () =>
      sortedUsers.reduce((prev, curr) => {
        if (
          !curr ||
          (!curr.firstName.toLowerCase().includes(searchParam.toLowerCase()) &&
            !curr.lastName.toLowerCase().includes(searchParam.toLowerCase()))
        ) {
          return { ...prev };
        }
        const fullName = `${curr.lastName} ${curr.firstName}`;
        const firstLetter = fullName[0];

        if (!prev[firstLetter]) {
          prev[firstLetter] = [];
        }

        prev[firstLetter] = [...prev[firstLetter], curr];
        return { ...prev };
      }, {} as IReducedUsers),
    [searchParam, sortedUsers],
  );
  const onFilter = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearchParam(event.target.value);
  }, []);

  return (
    <div className="col-3 border-right h100 pr-0">
      <div className="search-form px-2 pt-2">
        <form action="" className="form-search-contacts">
          <input type="text" className="small-input" placeholder="Search Contact..." onChange={onFilter} />
          <button type="button" className="small-submit">
            <img src={searchIcon} alt="search-icon" className="img-fluid" />
          </button>
        </form>
      </div>
      {sortedUsers && sortedUsers.length === 0 ? (
        <div className="contact-list">
          <p className="text-center text-muted py-4">This group is empty</p>
        </div>
      ) : (
        <div className="contact-list">
          {Object.keys(reduceByFullName).map((letter) => (
            <div key={letter}>
              <div className="letter-title border-bottom">{letter}</div>
              {reduceByFullName[letter].map(
                (user) => user && <UserWidget user={user} key={user.id} onUserSelect={onUserSelect} />,
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
